// extracted by mini-css-extract-plugin
module.exports = {"footerMain":"Footer_footerMain__2N5iJ"};